import { useMutation } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { CreateUser } from "../../../schemas/admin-user";

export function useCreateUser() {
	return useMutation({
		mutationFn: (data: CreateUser) => adminApi.users.create(data),
	});
}
